import React, { useEffect, useState } from 'react';
import './PromotionSecondaries.css';
import { Thumbnail } from '../PromotionThumbnail/Thumbnail';
import { PromotionsService } from '../../../../../shared/src/services/promotions.service';
import { PerfUtilService } from '../../../../../shared/src/services/util/perf-util.service';

export const PromotionSecondaries = ({
    secondaryPromotions = [],
}) => {
    const [layout, setLayout] = useState(null);

    // calculate layout
    useEffect(() => {
        if (Array.isArray(secondaryPromotions) && secondaryPromotions.length) {
            const calculateLayout = () => {
                setLayout(PromotionsService.getSecondaryPromotionsLayout(secondaryPromotions));
            };

            // initial calculation
            calculateLayout();

            // recalculate on resize
            const debouncedLayoutCalculation = PerfUtilService.debounce(calculateLayout, 100);
            window.addEventListener('resize', debouncedLayoutCalculation);

            return () => {
                window.removeEventListener('resize', debouncedLayoutCalculation);
            };
        }
    }, [secondaryPromotions]);

    if (!layout) {
        return null;
    }

    const {
        bigThumbnails,
        smallThumbnails,
    } = layout;

    return (
        <div className="asg-promotion-fold__secondaries">
            {bigThumbnails.length > 0 && (
                <div className="asg-promotion-fold__secondaries-grid asg-promotion-fold__secondaries-grid--big">
                    {bigThumbnails.map((promotion) => (
                        <Thumbnail
                            key={promotion.id}
                            promotion={promotion}
                            size="big"
                            className="asg-promotion-fold-thumbnail--secondary"
                        />
                    ))}
                </div>
            )}
            {smallThumbnails.length > 0 && (
                <div className="asg-promotion-fold__secondaries-grid asg-promotion-fold__secondaries-grid--small">
                    {smallThumbnails.map((promotion) => (
                        <Thumbnail
                            key={promotion.id}
                            promotion={promotion}
                            className="asg-promotion-fold-thumbnail--secondary"
                        />
                    ))}
                </div>
            )}
        </div>
    );
};
